import {Component} from '@angular/core';
import { Router } from '@angular/router';

import {AppComponent} from './app.component';
import { AuthService, UserConfig } from './shared/service/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-topbar',
    template: `
        <div class="topbar clearfix">
            <div class="topbar-left">
                <div class="logo"></div>
            </div>

            <div class="topbar-right">
                <a id="menu-button" href="#" (click)="app.onMenuButtonClick($event)">
                    <i></i>
                </a>

                <!-- <a id="rightpanel-menu-button" href="#" (click)="app.onRightPanelButtonClick($event)">
                    <i class="material-icons">more_vert</i>
                </a> -->

                <!-- <a id="topbar-menu-button" href="#" (click)="app.onTopbarMenuButtonClick($event)">
                    <i class="material-icons">menu</i>
                </a> -->

                <ul class="topbar-items animated fadeInDown ui-placeholder" style="cursor: pointer; text-align: center;">
                    <li *ngIf="aiEnabled$ | async" style="padding-left: 16px;">
                        <button (click)="app.onRightPanelButtonClick($event)" type="button" class="secondary ui-button ui-widget ui-state-default ui-corner-all ui-button-text-icon-left">
                            <span class="ui-button-icon-left ui-c fa fa-fw" style="font-size: 20px; margin-top: -13px; filter: grayscale(0.5);">✨</span>
                            <span class="ui-button-text ui-c">{{ 'easy_ai' | translate }}</span>
                        </button>
                    </li>

                    <li #theme [ngClass]="{'active-top-menu': changingLang}">
                        <p-dropdown [options]="languages" [(ngModel)]="selectedLang" placeholder="{{selectedLang && selectedLang.label || Language}}">
                            <ng-template let-item pTemplate="selectedItem">
                                <div (click)="changeLang(item.language)">
                                    <span style="vertical-align: middle">{{item.label}}</span>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </li>

                    <!--<li>
                        <button (click)="onLogout()" type="button" class="secondary ui-button ui-widget ui-state-default ui-corner-all ui-button-text-icon-left">
                            <span class="ui-button-icon-left ui-c fa fa-fw ui-icon-power-settings-new"></span>
                            <span class="ui-button-text ui-c">Sair do Sistema</span>
                        </button>
                    </li>
                    <li #profile class="profile-item" *ngIf="app.profileMode==='top'||app.isHorizontal()"
                        [ngClass]="{'active-top-menu':app.activeTopbarItem === profile}">

                        <a href="#" (click)="app.onTopbarItemClick($event,profile)">
                            <img class="profile-image" src="assets/layout/images/avatar.png"/>
                            <span class="topbar-item-name">Jane Williams</span>
                        </a>

                        <ul class="ultima-menu animated fadeInDown">
                            <li role="menuitem">
                                <a href="#">
                                    <i class="material-icons">person</i>
                                    <span>Profile</span>
                                </a>
                            </li>
                            <li role="menuitem">
                                <a href="#">
                                    <i class="material-icons">security</i>
                                    <span>Privacy</span>
                                </a>
                            </li>
                            <li role="menuitem">
                                <a href="#">
                                    <i class="material-icons">settings_applications</i>
                                    <span>Settings</span>
                                </a>
                            </li>
                            <li role="menuitem">
                                <a href="#">
                                    <i class="material-icons">power_settings_new</i>
                                    <span>Logout</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li #settings [ngClass]="{'active-top-menu':app.activeTopbarItem === settings}">
                        <a href="#" (click)="app.onTopbarItemClick($event,settings)">
                            <i class="topbar-icon material-icons">settings</i>
                            <span class="topbar-item-name">Settings</span>
                        </a>
                        <ul class="ultima-menu animated fadeInDown">
                            <li role="menuitem">
                                <a href="#">
                                    <i class="material-icons">palette</i>
                                    <span>Change Theme</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    -->
                </ul>
            </div>
        </div>
    `
})
export class AppTopBar {
    changingLang: boolean = false;

    languages: any[] = [];

    selectedLang = null;

    readonly aiEnabled$: Observable<boolean>;

    constructor(public app: AppComponent, private authService: AuthService, private router: Router) {
        this.loadLanguages();
        this.aiEnabled$ = this.authService.userConfig$.pipe(map((config: UserConfig) => config && config.aiEnabled));
    }

    onChangeLang = () => this.changingLang = !this.changingLang;

    changeLang(lang: string) {
        localStorage.setItem('language', lang);
        window.location.reload();
    }

    onLogout(){
        this.authService.setLogoutState();
        this.router.navigate(['/login']);
    }

    loadLanguages() {
        this.languages = [
            {
                label: 'Português',
                language: 'br',
                enabled: true
            },
            {
                label: 'English',
                language: 'en',
                enabled: true
            },
            // {
            //     label: 'Chinese',
            //     language: 'cc',
            //     enabled: false
            // }
        ];

        this.selectedLang = this.languages.find(
            (lang) => lang.language == (localStorage.getItem('language') || 'br')
        );
    }
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/app.topbar.component.ts